import React, { useEffect, useState } from "react";
import api from "../api/api"
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useAuth } from "../context/AuthContext";
import { useHistory } from "react-router-dom";
import PropTypes from 'prop-types';
import {useTranslation } from "react-i18next";
const ConfirmPublish = ({refreshData , selected_user}) => {


    const { t } = useTranslation();
    const {user} = useAuth();
    const navigate = useHistory();
    const schema = yup.object();
    const {
      reset,
      handleSubmit,
      setError,
      clearErrors,
      formState: { errors },
    } = useForm({
      resolver: yupResolver(schema),
      //defaultValues: inputValues,
    });


     const [loadingSendInv,setloadingSendInv] = useState(false)
     const [message,setmessage] = useState(null)

     
     const onSubmit = async(data) => {
        clearErrors();
        setmessage(null)
        let typeurl;
        if(user.type == "agency")typeurl="/invite-agency/"
        else if (user.type == "supplier")typeurl="/invite-supplier/"
        else return

        if (loadingSendInv) return;
        setloadingSendInv(true);
        
        
        try {

            const payload = {
                id_user: selected_user.id,
                ...data
            }
            const response = await api.patch(`biodata-status/${user.type}/${selected_user.id}/`, {status: "Published"});

 
                console.log("Form submitted successfully!");
                reset();
                setmessage("User published successfully!");
                    let btn_close = document.getElementById("btn-close-modal")
                    if (btn_close) {
                        btn_close.click();
                    // close modal    
                    refreshData();
                    setmessage(null)
                    }
            
               
            

        } catch (error) {
       
           let  errorMessage = ""
            // Extract response code if available
            const responseCode = error.response ? error.response.status : "Unknown";
            console.log("Response Code:", responseCode);
            if (error?.response?.data) {
                
                 Object.entries(error.response.data).forEach(([key, values]) => {
                   //if (key !== "token" && key !== "agency") {
                    
                     errorMessage += `${values}\n`;
                   //}
                 });
               }
             
               // If no specific error was found, provide a default message
               if (!errorMessage) {
                
                 errorMessage = "An unknown error occurred.";
               }
               
               // Set the error message in React Hook Form
               setError("root", { type: "server", message: errorMessage });
   
        } finally {
            setloadingSendInv(false);
        }
    }
        useEffect(()=>{
               
             
            clearErrors();
            },[])
    return (
        <div className="modal custom-modal modal-lg fade" id="modal_publish" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">
                    <div className="modal-header border-0 pb-0">
                        <div className="form-header modal-header-title text-start mb-0">
                            <h4 className="mb-0">{t("Publish Biodata")}</h4>
                        </div>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form  onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>{t("Are you sure you want to publish")} {selected_user?.name}?</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                        <small  style={{color:"green"}}> {message && <p>{message}</p>}</small>
                        <small  style={{color:"red"}}> {errors.root && <p>{errors.root.message}</p>}</small>
                            <button id="btn-close-modal" type="button" data-bs-dismiss="modal" className="btn btn-back cancel-btn me-2">{t("Cancel")}</button>
                            <button type="submit"  className="btn btn-primary " 
                            disabled={loadingSendInv} 
                            >{t("Yes")}
                            {loadingSendInv && <i className="fa-solid fa-spinner fa-spin" style={{margin: "0 10px"}}></i> }
                            </button>
                            
                        </div>
                    </form>
                </div>
            </div>
        </div>
    ); 
};
ConfirmPublish.propTypes = {
    refreshData: PropTypes.func.isRequired,
    selected_user: PropTypes.object.isRequired
  };
export default ConfirmPublish;
